<template>
  <div class="modal is-active">
    <link href="https://unpkg.com/uppy@0.27.2/dist/uppy.min.css" rel="stylesheet">

    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Add File</p>
        <div class="tabs is-right">
          <ul>
            <li :class="{'is-active': !linkMode}">
              <a href="" @click.prevent="linkMode = !linkMode">File</a>
            </li>
            <li :class="{'is-active': linkMode}">
              <a href="" @click.prevent="linkMode = !linkMode">Live Link</a>
            </li>
          </ul>
        </div>
      </header>
      <section class="modal-card-body">
        <div class="d-flex flex-column">

          <section v-if="!linkMode" class="">
            <p class="field flex-align-center">
              <input
                id="add-file"
                class="button is-primary"
                value="Upload File"
                type='button'
              />
              <span v-if="fileUploaded" class="is-success">File Uploaded!</span>
            </p>

            <input
              class="title is-5 input file-title-input"
              v-model="title"
              placeholder="file title"
            />
          </section>

          <section v-if="linkMode" class="">
            <input
              class="title is-5 input file-title-input"
              placeholder="link url (for things like google docs or google drive files)"
              v-model="url"
            />
            <input
              class="title is-5 input file-title-input"
              v-model="title"
              placeholder="title"
            />
          </section>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button
          v-if="!linkMode"
          :disabled="!fileUploaded"
          @click="addFile()"
          class="button is-info"
          :class="{ 'is-loading': loading }">
            Add
        </button>
        <button
          v-if="linkMode"
          :disabled="url.length<4"
          @click="addLink()"
          class="button is-info"
          :class="{ 'is-loading': loading }">
            Add
        </button>

        <button @click="close()" class="button">Cancel</button>
        <span v-if="errorAddingFile" class="is-danger">Error adding file</span>
      </footer>
    </div>
  </div>
</template>

<script>
import Core from '@uppy/core'
import Dashboard from '@uppy/dashboard'
import Webcam from '@uppy/webcam'
import AwsS3 from '@uppy/aws-s3'
import { S3_BUCKET_NAME } from '../settings'

import store from '../store.js'
import axios from 'axios'

import Raven from 'raven-js'

// import Raven from 'raven-js'

export default {
  name: 'AddFileModal',
  components: {
  },
  data () {
    return {
      linkMode: false,
      title: '',
      fileUploaded: false,
      key: '',
      size: '',
      source: '',
      mimetype: '',
      container: '',
      url: '',
      images: [],
      bytesUploaded: 0,
      bytesTotal: 0,
      showProgress: false,
      uppy: null,
      startTime: null,
      elapsedTime: 0,
    }
  },
  props: {
    videoID: {
      required: true,
    },
    cycleID: {
      required: false,
    },
  },
  methods: {
    close () {
      store.commit('toggleShowAddFileModal', false)
    },
    showUploader () {
      const filename = new Date().getTime()
      const originalPath = `/file/${this.user.id}/${filename}/`
      console.log(originalPath)
    },
    addFile () {
      console.log('addFile')
      const data = {
        title: this.title,
        fileUploaded: this.fileUploaded,
        key: this.key,
        size: this.size,
        source: this.source,
        ftype: this.mimetype,
        container: this.container,
        video: this.videoID,
      }
      const cycleID = this.cycleID
      const videoID = this.videoID
      store.dispatch('createFile', { cycleID, videoID, data })
    },
    addLink () {
      console.log('addLink')
      const data = {
        title: this.title,
        fileUploaded: this.url,
        key: this.url,
        video: this.videoID,
        ftype: 'link',
      }
      const cycleID = this.cycleID
      const videoID = this.videoID
      store.dispatch('createFile', { cycleID, videoID, data })
    },
    updateValues (file) {
      let key = file.uploadURL.split('?')[0]
      key = key.replace(`https://s3.amazonaws.com/${S3_BUCKET_NAME}/`, '')
      // just get the timestamp
      const timestamp = key.split('/')[3]

      this.key = 'v2/' + this.user.id + '/resources/' + timestamp + '/' + file.name

      this.title = file.name
      this.size = Math.round(file.size / 1000)
      this.source = file.source
      this.container = S3_BUCKET_NAME
      this.mimetype = file.extension

      this.fileUploaded = true
    },
  },
  computed: {
    errorAddingFile () {
      return store.state.errorAddingFile
    },
    loading () {
      return store.state.addingFile
    },
    user () {
      return store.state.user
    },
  },
  mounted () {
    this.uppy = new Core({
      debug: process.env.NODE_ENV === 'development',
      id: 'uppy',
      autoProceed: true,
      restrictions: {
        maxFileSize: false,
        maxNumberOfFiles: 1,
        minNumberOfFiles: 1,
      },
      onBeforeUpload: () => {
        this.startTime = new Date()
      },
    })

    this.uppy
      .use(Dashboard, {
        trigger: '#add-file',
        inline: false,
        showProgressDetails: true,
        hideUploadButton: true,
        proudlyDisplayPoweredByUppy: false,
        locale: {
          strings: {
            selectToUpload: 'Select your file to upload',
            dropPasteImport: 'Drag your file here, import from one of the locations above, or',
          },
        },
      })
      .use(AwsS3, {
        // host: 'http:127.0.0.1.xip.io:8000',
        getUploadParameters (file) {
          const ms = new Date().getTime()
          console.log(`filename: ${ms}/original/${file.name}`)
          return axios.post('/api/v1/presigned-url/', { filename: `resources/${ms}/${file.name}`, contentType: file.type, ms: ms },
            { headers: { 'Authorization': 'Token ' + localStorage.getItem('token') } })
            .then(response => {
              console.log(response.data)
              return {
                method: 'PUT',
                url: response.data.presignedUrl,
                fields: {},
              }
            })
            .catch(error => {
              console.warn('error with presigned url', error)
              Raven.captureException(error)
            })
        },
      })
      .use(Webcam, { target: Dashboard })
    this.uppy.on('complete', result => {
      this.elapsedTime = (new Date() - this.startTime) / 1000
      console.log(this.elapsedTime)
      console.log('successful files:', result.successful)
      this.updateValues(result.successful[0])
      // FIXME: Need better error handling
      console.log('failed files:', result.failed)
      this.uppy.getPlugin('Dashboard').closeModal()
      this.uppy.reset()
      store.commit('notify', { message: 'File uploaded successfully', level: 'success' })
    })
  },
  beforeDestroy () {
    // since uppy puts stuff in the body, we need to delete it
    // we could have uppy put stuff inside the vue component but that results
    // in artifacts during the initial render
    this.uppy.close()
  },
}

</script>

<style lang="scss" scoped>

.file-upload {
  margin-bottom: 1.5rem;
}

.file-title-input {
  width: 100%;
}

@import '../_variables.scss';

.is-danger {
  color: $DANGER;
}

.is-success {
  color: $SUCCESS;
  padding-right: 10px;
  padding-left: 10px;
}

</style>



// WEBPACK FOOTER //
// AddFileModal.vue?1b3c8b49